(function() {
  'use strict';

  function EmailTypesComponentController(Router, $rootScope, Profile, EmailTypeSearch,
      EmailTypes, EmailType, List, Security, $translate, Utils) {
    var ctrl = this;
    ctrl.options = {
      trackBy: 'doc.id'
    };

    // Function to handle navigation to email type
    ctrl.navigateToEmailType = function(id) {
      Router.navigate(['/emails', id]);
    };

    Utils.setPageTitle('Email types');

    ctrl.searchModel = Profile.getListPreferences('emailTypes').current;
    var makeDocs = function(item) {
      return new EmailType(item);
    };

    ctrl.list = new List({
      search: EmailTypeSearch.search,
      model: ctrl.searchModel,
      idField: 'doc.id'
    });
    $rootScope.$broadcast('KZCurrentListChange', { list: 'emailTypes', search: ctrl.list.search });

    EmailTypes.findAll({}, {}, { noCache: true })
      .then(function(data) {
        if (data.length > 0) {
          ctrl.list.doLoadItems(data.map(makeDocs));
        }
      }).catch(function(err) {
        console.log(err);
      });

    ctrl.actions = [
      {
        label: $translate.instant('View sent emails'),
        icon: 'icon-envelope-o',
        route: ['/emails/log'],
        showCondition: Security.hasPermission.bind(this, 'emailTemplates.view'),
        klass: 'btn-info'
      }
    ];

    // Defined here so that I don't have to create a special slot that does nothing
    ctrl.options.actionButtons = function(item) {
      return [
        {
          label: $translate.instant('Edit'),
          icon: 'icon-edit',
          route: ['/emails', item.doc.id],
          showCondition: Security.hasPermission.bind(this, 'emailTemplates.view'),
          klass: 'text-info'
        }
      ];
    };
  }

  EmailTypesComponentController.$inject = [
    'Router',
    '$rootScope',
    'ProfileService',
    'EmailTypeSearch',
    'EmailTypesService',
    'EmailTypeFactory',
    'ListFactory',
    'SecurityService',
    '$translate',
    'UtilsService'
  ];

  angular.module('component.emailTemplates')
    .component('emailTypesComponent', {
      templateUrl: 'app/components/email-templates/email-types.html',
      controller: EmailTypesComponentController
    });
})();
